options =
  renderer: new window.marked.Renderer()
  gfm: true
  tables: true
  breaks: false
  pedantic: false
  sanitize: false
  smartLists: true
  smartypants: true
  headerPrefix: 'ed_'     # Prevent CSS overrides using 'id' for certain words, eg: 'content'

# This method recurs through the slide data, matching each property against
# the original model definition so that it can be processed according to
# it's specified type. It handles multi-content properties by setting the
# type using the "keyType" syntax. For example, the `title` on multiple choice
# may have a `titleType` of "image", "text", etc.
recur = (obj, def, method, config = {}) ->
  if not(obj?) or not(def?) or typeof obj isnt "object"
    method(obj, def, config)
  else if (Array.isArray or _.isArray) obj
    obj.map (t, i) -> recur(t, def.type[0], method, config)
  else
    result = {}
    for key, val of obj
      t = obj["#{key}Type"]
      m = def[key]
      if m?
        m.type = t if t
        m.type = m.types[0] if t is "" and m.types?
      result[key] = recur(val, m, method, config)

    result

# Trim whitespace from the result, and ditch the paragraph if it's a one-liner.
# Lists get a "md-list" class so we can apply some specific typographic styles.
markdown = (content, config = {}) ->
  try
    nbLines = content.split?(/\n|\<p[^\>]*\>/).length
    result  = window.marked content.toString(), options
    if config.direction == 'rtl'
      # swap opening/closing single quotes
      result  = result.replace(/[\u2018\u2019]/g, ($1) => if ($1 == '\u2018') then '\u2019' else '\u2018')
      # swap opening/closing double quotes
      result  = result.replace(/[\u201c\u201d]/g, ($1) => if ($1 == '\u201c') then '\u201d' else '\u201c')
    result  = result.replace(/(^\s+|\s+$)/g, "")
    result  = result.replace(/\<\/?p[^\>]*\>/g, "") if nbLines <= 1
    result  = result.replace(/\<(ul|ol)\>/g, "<$1 class='md-list'>")
    result
  catch err
    content

hasHtmlTags = (content) -> /<\/?[a-z][\s\S]*>/i.test content

html = (content) ->
  if hasHtmlTags content
    try
      new DOMParser().parseFromString(content, 'text/html').body.innerHTML
    catch err
      content
  else
    content

transformTypes = ["text", "html"]

shouldTransform = (def) ->
  if def?.type or def?.types
    _.includes(transformTypes, def.type or def.types[0])
  else
    false

# For each value of type "text" or "html", process as markdown.
transform = (value, def, config = {}) ->
  if shouldTransform(def) and not(def.transform is false)
    transformed = markdown(value, config)
    html transformed
  else
    value

_processedSlides = {}
processSlide = (data, type,  config = {}) ->
  key   = sha1(JSON.stringify({ data, type }))
  return _processedSlides[key] if _processedSlides[key]?

  model  = require("engine/#{type}/model")?.model
  result = _.extend data, recur(data, model, transform, config)
  _processedSlides[key] = result
  return result

processSlides = (data) ->
  slide.data = processSlide(slide.data, slide.type, data.config) for slide in data.slides
  data

isURL = (c) ->
  c?.indexOf('http') is 0 or c?.indexOf("fit_content_assets") isnt -1

formatContent = (f) -> (c) ->
  if not isNaN(c)
    if c.split('.').length > 1
      parseFloat(c).toFixed(c.split('.')[1].length) #conserve trailing zeros
    else 
      parseFloat(c)
  else if isURL(c)
    c
  else
    f(c)

processMetadata = (func) -> (metadata) ->
  for q, i in (metadata.questions or []) when q?.question?
    metaDataPath = metadata.questions[i]
    if q?.question?.content
      metaDataPath.question.content =
        formatContent(func)(q.question.content.toString())
    if q?.question?.category
      metaDataPath.question.category =
        formatContent(func)(q.question.category.toString())

    for answer, j in q.answers when answer?.content?
      metaDataPath.answers[j].content =
        formatContent(func)(answer.content.toString())
  metadata

deepClone = _.compose JSON.parse, JSON.stringify

# Metadata is a unified format for question/answers for each template.
# We process it here so all templates receive the same markdown processing
# Please use this data to render slides so data is displayed consistently
processSlidesMetadata = (data) ->
  for slide in data.slides when slide?.metadata?
    slide.metadata =
      processMetadata(markdown)(deepClone(slide.metadata))
    slide.strippedMetadata =
      processMetadata(removeMarkdown)(deepClone(slide.metadata))
  data

module.exports =
  one: processSlide
  oneMD: processMetadata(markdown)
  oneSMD: processMetadata(removeMarkdown)
  all: processSlides
  allMD: processSlidesMetadata